// src/components/wellfinder/fmtDistance.js
//
// One distance format for the review view, shared by the candidate cards and
// the holder chip — the chip sets two distances side by side, and they must
// read the same way as the card they came from.

export function fmtDistance(m) {
  if (m == null) return "—";
  // Sub-metre below 10m: p50 nearest is 4.78m, so that band is where the
  // analyst's calibration actually lives and rounding it to "5 m" throws away
  // the discrimination.
  return m < 10 ? `${m.toFixed(1)} m` : `${Math.round(m)} m`;
}
